import { useCallback, useEffect, useState } from 'react'
import { PriceDocumentInterface } from '../../../../common/types/interfaces'
import { getSalesApi } from '../../../../salesApi/salesApi'
import { useSelector } from 'react-redux'
import { selectCurrentCluster } from '../../../../store/slices/currentClusterSlice'
import { PriceDocumentType } from '../../../../common/types/enums'

const initialDocument: Partial<PriceDocumentInterface> = {
  number: '',
  comment: '',
  prices: [],
}

export const usePrice = () => {
  const [modalActive, setModalActive] = useState<boolean>(false)
  const [edit, setEdit] = useState<boolean>(false)
  const [salesApi] = useState(getSalesApi())
  const [document, setDocument] = useState<Partial<PriceDocumentInterface>>(initialDocument)
  const [documentType, setDocumentType] = useState<PriceDocumentType>(PriceDocumentType.MANUAL)
  const [list, setList] = useState<PriceDocumentInterface[]>([])
  const [detailsModalActive, setDetailsModalActive] = useState<boolean>(false)
  const [current, setCurrent] = useState<PriceDocumentInterface>()
  const currentCluster = useSelector(selectCurrentCluster)
  const [loading, setLoading] = useState(true)

  const getList = useCallback(async () => {
    try {
      const result = await salesApi.getPriceDocumentList()
      setLoading(false)
      if (result) setList(result)
    } catch (error) {
      setLoading(false)
    }
  }, [salesApi])

  const startCreate = (type: PriceDocumentType = PriceDocumentType.MANUAL) => {
    setEdit(false)
    setDocumentType(type)
    setCurrent(undefined)
    setDocument({ ...initialDocument, prices: [] })
    setModalActive(true)
  }

  const startEdit = (el: PriceDocumentInterface) => {
    setEdit(true)
    setDocumentType(el.type)
    setCurrent(el)
    setDocument({ ...el })
    setModalActive(true)
  }

  const showDetails = useCallback((el: PriceDocumentInterface) => {
    setCurrent(el)
    setDetailsModalActive(true)
  }, [])

  const addPrice = () => {
    setDocument((prev) => ({
      ...prev,
      prices: [{ saleItemId: '', price: 0 }, ...(prev.prices || [])],
    }))
  }

  const removePrice = (index: number) => {
    setDocument((prev) => ({
      ...prev,
      prices: prev.prices?.filter((_, i) => i !== index),
    }))
  }

  const updatePrice = (index: number, field: string, value: any) => {
    setDocument((prev) => ({
      ...prev,
      prices: prev.prices?.map((item, i) => (i === index ? { ...item, [field]: value } : item)),
    }))
  }

  useEffect(() => {
    if (currentCluster) getList()
  }, [currentCluster, getList])

  useEffect(() => {
    if (!modalActive) {
      setDocument(initialDocument)
      setDocumentType(PriceDocumentType.MANUAL)
    }
  }, [modalActive])

  return {
    getList,
    modalActive,
    setModalActive,
    startCreate,
    startEdit,
    edit,
    document,
    setDocument,
    documentType,
    list,
    detailsModalActive,
    setDetailsModalActive,
    showDetails,
    current,
    loading,
    addPrice,
    removePrice,
    updatePrice,
  }
}
